import { Avatar, AvatarImage } from 'src/shared/components/ui/miscellaneous/avatar'
import { Dialog, DialogContent } from 'src/shared/components/ui/popups/dialog'

interface ProfileAvatarDialogProps {
  isOpen: boolean
  setOpen: (open: boolean) => void
  photo: string
}

export default function ProfileAvatarDialog({ isOpen, setOpen, photo }: ProfileAvatarDialogProps) {
  return (
    <Dialog open={isOpen} onOpenChange={setOpen}>
      <DialogContent
        hideClose={true}
        className="w-auto max-w-none border-none bg-transparent focus-visible:outline-none"
      >
        <Avatar
          className={`size-[250px] overflow-hidden rounded-full border-8 border-white bg-accent shadow-[0_1px_6px_1px_rgba(27,48,41,0.10)] transition-all duration-300 md:size-[400px]`}
        >
          <AvatarImage src={photo} alt={'user profile photo'} className="size-full object-cover" />
        </Avatar>
      </DialogContent>
    </Dialog>
  )
}
